import * as types from "./ErrorTypes";

export const setErrorMessage = ({
  message,
  title = null,
  type = null,
  showAs = null,
  noAutoClose,
  specialAlert = false,
}) => {
  return {
    type: types.SET_ERROR,
    action: {
      message,
      title,
      type,
      showAs,
      noAutoClose,
      specialAlert,
    },
  };
};

export const resetErrorMessage = () => {
  return {
    type: types.RESET_ERROR,
  };
};
